exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Discussion-CommentHead-Root {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: space-between;\n}\n.Discussion-CommentHead-Buttons {\n  display: flex;\n  flex-flow: row nowrap;\n  margin: 0 -4px;\n  opacity: 0;\n  transition: opacity 0.5s;\n}\n@media (max-width: 480px) {\n  .Discussion-CommentHead-Buttons {\n    opacity: 1;\n  }\n}\n.Discussion-CommentHead-Button {\n  margin: 0 4px;\n}\n", ""]);

// exports
